import { makeServerSideApolloClient } from './create-apollo-client.server';
import { makeClientSideApolloClient } from './create-apollo-client.client';

export const ApolloClient = typeof window !== 'undefined' ? makeClientSideApolloClient() : makeServerSideApolloClient();
